import React from "react"
import { useCustomQuery } from "hooks/useCustomQuery"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import { ProfileOfferService } from "services/api-service"
import { SurveyAnswerType } from "services/api-service/types"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"
import Spinner from "ui/components/atoms/spinner"
import { Label, P } from "ui/components/atoms/typography"
import Modal from "ui/components/molecules/modal"

const OfferSurveyAnswerModal = () => {
  const { t } = useTranslation(["panel"])
  const navigate = useNavigate()
  const { offerId = "", applicationId = "" } = useParams()

  const { isLoading, data } = useCustomQuery<SurveyAnswerType>(
    { key: ["survey", offerId, applicationId] },
    () => ProfileOfferService.getOfferApplicationSurvey(offerId, applicationId),
  )

  return (
    <Modal
      show={true}
      setShow={() => navigate(`/panel/offers/${offerId}/applications`)}
      type="center"
      title={data?.name}
      $maxWidth="600px"
    >
      <Wrapper>
        {isLoading ? (
          <Box>
            <Spinner />
          </Box>
        ) : (
          <Content>
            {data?.answers.map((el, index) => {
              return (
                <AnswerWrapper key={index}>
                  <P $small $marginBottom="XS">
                    {el.title}
                  </P>
                  <Label $marginBottom="0">{`${el.answer}`}</Label>
                </AnswerWrapper>
              )
            })}
          </Content>
        )}
      </Wrapper>
    </Modal>
  )
}

export default OfferSurveyAnswerModal

const AnswerWrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.XS};
  background: ${({ theme }) => theme.color.background};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
`

const Content = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space.XS};
`

const Wrapper = styled(Box)``
